import { render, staticRenderFns } from "./NetpeakFooter.vue?vue&type=template&id=61013df0"
import script from "./NetpeakFooter.vue?vue&type=script&lang=js"
export * from "./NetpeakFooter.vue?vue&type=script&lang=js"
import style0 from "./NetpeakFooter.vue?vue&type=style&index=0&id=61013df0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports